import { render, staticRenderFns } from "./QrCode.vue?vue&type=template&id=498a78d2"
import script from "./QrCode.vue?vue&type=script&lang=js"
export * from "./QrCode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('498a78d2')) {
      api.createRecord('498a78d2', component.options)
    } else {
      api.reload('498a78d2', component.options)
    }
    module.hot.accept("./QrCode.vue?vue&type=template&id=498a78d2", function () {
      api.rerender('498a78d2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/qr/QrCode.vue"
export default component.exports